import React from 'react';
import { MailIcon, MessageSquareIcon, ClockIcon, HelpCircleIcon } from 'lucide-react';
export function SupportContent() {
  return <div className="space-y-6" data-id="element-1175">
      <p className="text-gray-700 mb-6" data-id="element-1176">
        Estamos aquí para ayudarte con cualquier pregunta o problema que tengas
        con nuestro producto. Elige la opción que mejor se adapte a tu
        necesidad:
      </p>

      {/* Contact Options */}
      <div className="grid md:grid-cols-2 gap-4" data-id="element-1177">
        {/* Email Support */}
        <div className="bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1178">
          <div className="flex items-center gap-3 mb-4" data-id="element-1179">
            <div className="w-12 h-12 bg-baby-gradient-blue rounded-full flex items-center justify-center" data-id="element-1180">
              <MailIcon className="w-6 h-6 text-white" data-id="element-1181" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1182">
              Email de Soporte
            </h3>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-1183">
            Envíanos un email y te responderemos en menos de 24 horas.
          </p>
          <a href="mailto:contactomikioscodigital@gmail.com" className="inline-flex items-center gap-2 text-baby-blue-dark hover:text-baby-blue font-bold transition" data-id="element-1184">
            <MailIcon className="w-4 h-4" data-id="element-1185" />
            contactomikioscodigital@gmail.com
          </a>
        </div>

        {/* Contact Form */}
        <div className="bg-gradient-to-br from-baby-pink-light to-baby-blue-light p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1186">
          <div className="flex items-center gap-3 mb-4" data-id="element-1187">
            <div className="w-12 h-12 bg-baby-gradient-pink rounded-full flex items-center justify-center" data-id="element-1188">
              <MessageSquareIcon className="w-6 h-6 text-white" data-id="element-1189" />
            </div>
            <h3 className="text-xl font-bold text-gray-900" data-id="element-1190">
              Formulario de Contacto
            </h3>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-1191">
            Usa nuestro formulario de contacto para enviarnos tu consulta
            detallada.
          </p>
          <p className="text-baby-pink-dark font-bold" data-id="element-1192">
            Disponible en el footer → Contacto
          </p>
        </div>
      </div>

      {/* Support Hours */}
      <div className="bg-baby-cream p-6 rounded-baby-lg border-2 border-baby-lavender" data-id="element-1193">
        <div className="flex items-center gap-3 mb-4" data-id="element-1194">
          <ClockIcon className="w-6 h-6 text-baby-blue" data-id="element-1195" />
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1196">
            Horario de Atención
          </h3>
        </div>
        <div className="space-y-2 text-gray-700" data-id="element-1197">
          <p data-id="element-1198">
            <strong data-id="element-1199">Lunes a Viernes:</strong> 9:00 AM - 6:00 PM (GMT-5)
          </p>
          <p data-id="element-1200">
            <strong data-id="element-1201">Sábados:</strong> 10:00 AM - 2:00 PM (GMT-5)
          </p>
          <p data-id="element-1202">
            <strong data-id="element-1203">Domingos:</strong> Cerrado
          </p>
          <p className="text-sm text-gray-600 mt-3" data-id="element-1204">
            * Los emails recibidos fuera del horario serán respondidos el
            siguiente día hábil
          </p>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white p-6 rounded-baby-lg border-2 border-baby-blue-light" data-id="element-1205">
        <div className="flex items-center gap-3 mb-4" data-id="element-1206">
          <HelpCircleIcon className="w-6 h-6 text-baby-blue" data-id="element-1207" />
          <h3 className="text-lg font-bold text-gray-900" data-id="element-1208">
            Preguntas Frecuentes
          </h3>
        </div>
        <div className="space-y-4" data-id="element-1209">
          <div data-id="element-1210">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1211">
              ¿Cómo descargo mi producto?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1212">
              Después de completar tu compra, recibirás un email con el link de
              descarga. Revisa tu bandeja de spam si no lo encuentras.
            </p>
          </div>
          <div data-id="element-1213">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1214">
              ¿Puedo solicitar un reembolso?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1215">
              Sí, ofrecemos garantía de 30 días. Contáctanos a{' '}
              <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-1216">
                contactomikioscodigital@gmail.com
              </a>{' '}
              con tu número de orden.
            </p>
          </div>
          <div data-id="element-1217">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1218">
              ¿El producto está en español?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1219">
              Sí, todo el contenido está 100% en español, adaptado para LATAM.
            </p>
          </div>
          <div data-id="element-1220">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-1221">
              ¿Necesito conocimientos previos?
            </h4>
            <p className="text-gray-700 text-sm" data-id="element-1222">
              No, las recetas están diseñadas para mamás primerizas sin
              experiencia culinaria.
            </p>
          </div>
        </div>
      </div>

      {/* Response Time */}
      <div className="bg-gradient-to-r from-baby-blue-light to-baby-pink-light p-4 rounded-baby text-center border-2 border-baby-lavender" data-id="element-1223">
        <p className="text-gray-900 font-bold" data-id="element-1224">
          ⏱️ Tiempo promedio de respuesta:{' '}
          <span className="text-baby-blue-dark" data-id="element-1225">Menos de 24 horas</span>
        </p>
      </div>
    </div>;
}